import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const FileList = styled.div`
  width: 100%;
  display: flex;
  margin-top: 16px;
`;

export const FileInfo = styled.div`
  width: 248px;
  display: flex;
  flex-direction: column;
  white-space: nowrap;

  p {
    font-weight: bold;
    margin-bottom: 16px;
  }

  strong {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
`;

export const LabelFileInput = styled.label`
  height: 36.5px;
  padding: 6px 16px;
  background-color: #fff;
  color: #e38500;
  font-size: 15px;
  border-radius: 4px;
  border: 1px solid rgba(227, 133, 0, 0.5);
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: background-color 0.2s, border-color 0.2s;

  &:hover {
    background-color: #fefaf5;
    border: 1px solid #e38500;
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const IconButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 4px;
  border-radius: 50%;
  background: transparent;
  border: none;
  outline: none;

  svg {
    color: #004e9a;
    transition: color 0.2s;
  }

  &:hover {
    svg {
      color: #00366b;
    }
  }
`;
